import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import { SPECIALISTS, SpecialistServicePath } from "utils/constants";
import ListSpecialists from "./List";
import permissions from "app/permissions";
import ShowSpecialist from "./Show/Show";
import { tenants } from "utils/tenants";

//permissions
export const resources = {
  isMenu: true,
  tenancies: [tenants.MU],
  icon: <PeopleOutlineIcon />,
  name: SpecialistServicePath + SPECIALISTS,
  title: "Специализанти",
  list: <ListSpecialists />,
  show: <ShowSpecialist />,
  permission: permissions.canPreviewSpecialists,
};
